import { Quill } from 'vue-quill-editor';
// 源码中是import直接倒入，这里要用Quill.import引入
const BlockEmbed = Quill.import('blots/block/embed');
const Link = Quill.import('formats/link');

const ATTRIBUTES = ['height', 'width'];

class Img extends BlockEmbed {
  static create(value) {
    const node = super.create(value);
    // console.log(value.split('.').pop(), 'img===========================');
    // 添加Img标签所需的属性
    node.setAttribute('src', this.sanitize(value));
    return node;
  }

  static formats(domNode) {
    return ATTRIBUTES.reduce((formats, attribute) => {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  static sanitize(url) {
    return Link.sanitize(url); // eslint-disable-line import/no-named-as-default-member
  }

  static value(domNode) {
    return domNode.getAttribute('src');
  }

  format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }

  html() {
    const { img } = this.value();
    return `<a href="${img}">${img}</a>`;
  }
}
Img.blotName = 'img'; // 这里不用改，楼主不用iframe，直接替换掉原来，如果需要也可以保留原来的，这里用个新的blot
Img.className = 'ql-img';
Img.tagName = 'img'; // 用video标签替换iframe

export default Img;



// WEBPACK FOOTER //
// ./src/util/quill/img.js